import React from "react";

interface Props {
	data: Record<string, any>[];
	valueKey: string;
	labelKey: string;
	color?: string;
}

export const BarChart: React.FC<Props> = ({
	data,
	valueKey,
	labelKey,
	color = "#06a384",
}) => {
	const max = Math.max(...data.map((d) => Number(d[valueKey])));
	return (
		<div className="bar-chart">
			{data.map((d, i) => {
				const v = Number(d[valueKey]);
				return (
					<div key={i} className="bar-col">
						<div className="bar-value">
							{v > 999 ? `${(v / 1000).toFixed(1)}K` : v.toFixed(0)}
						</div>
						<div
							className="bar-fill"
							style={{
								height: `${Math.max(5, (v / max) * 90)}%`,
								background: color,
								opacity: i === data.length - 1 ? 1 : 0.6,
							}}
						/>
						<div className="bar-label">{d[labelKey]}</div>
					</div>
				);
			})}
		</div>
	);
};
